import { momentCustomInstance as moment } from '@projects/shared/src/app/utils/helper';
import { NotificationsService } from '@shared/services/notifications.service';
import { Component, OnInit } from '@angular/core';
import { NavService } from '@projects/shared/src/app/services/nav.service';
import { ParticipantChannelType } from '@projects/shared/src/app/features/chat/interfaces/transcript/ConversationAndOfflineMessagesResponse';
import { ConversationService } from '@projects/shared/src/app/features/chat/services/conversation/conversation.service';
import { Router } from '@angular/router';
import { animate, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'requests',
  templateUrl: './requests.component.html',
  styleUrls: ['./requests.component.scss'],
  animations: [
    trigger('openClose', [
      transition(':enter', [
        style({ transform: 'translateX(100%)' }),
        animate('400ms', style({ transform: 'translateX(0)' })),
      ]),
      transition(':leave', [
        style({ transform: 'translateX(0)' }),
        animate('400ms', style({ transform: 'translateX(100%)' })),
      ]),
    ]),
  ],
})
export class RequestsComponent implements OnInit {
  moment = moment;

  constructor(
    public navService: NavService,
    public notificationsService: NotificationsService,
    public convService: ConversationService,
    private router: Router
  ) {}

  ngOnInit(): void {}

  getChannelName(channelType: number) {
    return channelType == ParticipantChannelType.Web
      ? 'WEB'
      : channelType == ParticipantChannelType.Messenger
      ? 'Messenger'
      : channelType == ParticipantChannelType.WhatsApp
      ? 'WhatsApp'
      : channelType == ParticipantChannelType.Instagram
      ? 'Instagram'
      : 'SMS';
  }
  getIcon(channelType: number) {
    let icon =
      channelType == ParticipantChannelType.Web
        ? 'fa-light fa-globe social-icon'
        : channelType == ParticipantChannelType.Messenger
        ? 'fa-brands fa-facebook-messenger social-icon social-icon--fb'
        : channelType == ParticipantChannelType.WhatsApp
        ? 'fa-brands fa-whatsapp social-icon social-icon--wa'
        : channelType == ParticipantChannelType.Instagram
        ? 'fa-brands fa-instagram social-icon social-icon--ig'
        : 'fa-regular fa-comment-sms social-icon social-icon--wa';

    return icon;
  }
  acceptChat(index: any, request: any) {
    this.convService.acceptChat(index, request);
    this.navService.toggleRequestPane();
    this.router.navigate(['/agent/chats/live']);
  }
  toggleDetails(req: any) {
    req.showDetails = !req.showDetails;
  }
}
